module.exports = __webpack_public_path__ + "static/media/ChangePIN-DebitPrepaid.f1d24aa2.png";